import POSState from 'features/POSRegisters/interfaces/POSState';
import POSResponseData from 'features/POSRegisters/interfaces/POSResponseData';
import nposApiNormalizer from './nposApiNormalizer';
import mockData from '../mockData';

//#region INITIAL_STATE
export const initialState: POSState = {
  siteId: null,
  isPOSDataReady: false,
  cloudServices: [],
  networkCircuits: [],
  networkSwitches: [],
  ipads: [],
  ipadsMini: [],
  receiptPrinters: [],
  cashDrawers: [],
  barcodeScanners: [],
  paymentTerminals: [],
  registers: [],
};
//#endregion INITIAL_STATE

//#region ACTIONS
export const actionTypes = {
  UPDATE_SITE_ID: 'UPDATE_SITE_ID',
  UPDATE_POS_DATA: 'UPDATE_POS_DATA',
  RESET_POS_DATA: 'RESET_POS_DATA',
  USE_TEST_SITE: 'USE_TEST_SITE',
} as const;

type ActionType = typeof actionTypes;

type Action =
  | {type: ActionType['UPDATE_SITE_ID']; payload: string}
  | {type: ActionType['UPDATE_POS_DATA']; payload: POSResponseData}
  | {type: ActionType['RESET_POS_DATA']}
  | {type: ActionType['USE_TEST_SITE']};
//#endregion ACTIONS

//#region REDUCER
export const reducer = (state: POSState, action: Action): POSState => {
  switch (action.type) {
    case 'UPDATE_SITE_ID':
      return {
        ...state,
        siteId: action.payload,
      };
    case 'UPDATE_POS_DATA':
      return updatePOSDataFromAPI(state, action.payload);
    case 'RESET_POS_DATA':
      return {
        ...initialState,
      };
    case 'USE_TEST_SITE':
      const insertTestData = (mockData as unknown) as POSResponseData;
      return updatePOSDataFromAPI(state, insertTestData);

    default:
      return state;
  }
};
//#endregion REDUCER

//#region UPDATE_POS_DATA
function updatePOSDataFromAPI(state: POSState, apiData: POSResponseData) {
  return {
    ...state,
    ...nposApiNormalizer(apiData),
    isPOSDataReady: true,
  };
}
//#endregion UPDATE_POS_DATA
